// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0c4a158","453":"64aababc"}[chunkId] + ".chunk.js";
};